import { render, staticRenderFns } from "./createXuqiu.vue?vue&type=template&id=63417daf&scoped=true"
import script from "./createXuqiu.vue?vue&type=script&lang=js"
export * from "./createXuqiu.vue?vue&type=script&lang=js"
import style0 from "./createXuqiu.vue?vue&type=style&index=0&id=63417daf&prod&scoped=true&lang=css"
import style1 from "./createXuqiu.vue?vue&type=style&index=1&id=63417daf&prod&lang=css"
import style2 from "./createXuqiu.vue?vue&type=style&index=2&id=63417daf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63417daf",
  null
  
)

export default component.exports